function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { componentsSchemas } from "./component-schemas";
export var ComponentDataReceiver = /*#__PURE__*/function () {
  function ComponentDataReceiver(component, componentName) {
    _classCallCheck(this, ComponentDataReceiver);
    this.component = component;
    this.componentName = componentName;
  }
  return _createClass(ComponentDataReceiver, [{
    key: "getComponentData",
    value: function getComponentData() {
      var schema = componentsSchemas[this.componentName].data;
      var data = {};
      for (var key in schema) {
        var name = schema[key].name;
        var element = schema[key].element;
        var type = schema[key].type;
        var selectedElement = this.component.querySelector(element);
        var elementData = void 0;
        if (selectedElement !== null && selectedElement !== undefined) {
          elementData = ComponentDataReceiver.getElementDataByType(type, selectedElement);
        } else {
          elementData = null;
        }
        data[name] = elementData;
      }
      return data;
    }
  }], [{
    key: "getElementDataByType",
    value: function getElementDataByType(type, element) {
      var typesMap = {
        image: ComponentDataReceiver._getComponentImage,
        mobileImage: ComponentDataReceiver._getComponentMobileImage,
        imageComponent: ComponentDataReceiver._getComponentImageComponent,
        video: ComponentDataReceiver._getComponentVideo,
        iframe: ComponentDataReceiver._getComponentIframe,
        html: ComponentDataReceiver._getComponentHtml,
        link: ComponentDataReceiver._getComponentLink,
        text: ComponentDataReceiver._getComponentText,
        json: ComponentDataReceiver._getComponentJson,
        newsListSpot: ComponentDataReceiver._getComponentNewsListSpot,
        newsNavigation: ComponentDataReceiver._getComponentNewsNavigation,
        imageSpotList: ComponentDataReceiver._getComponentImageSpotList,
        colorSpotContent: ComponentDataReceiver._getComponentColorSpot,
        linkList: ComponentDataReceiver._getComponentLinkList,
        search: ComponentDataReceiver._getComponentSearch,
        navigation: ComponentDataReceiver._getComponentNavigation,
        breadcrumb: ComponentDataReceiver._getComponentBreadcrumb,
        blogCategories: ComponentDataReceiver._getComponentBlogCategories
      };
      return typesMap[type](element);
    }
  }, {
    key: "_getComponentImage",
    value: function _getComponentImage(image) {
      return {
        image: image,
        src: image.src,
        alt: image.alt,
        height: image.height,
        width: image.width
      };
    }
  }, {
    key: "_getComponentMobileImage",
    value: function _getComponentMobileImage(mobileImage) {
      if (typeof mobileImage['mobile-image'] !== "undefined") {
        return {
          src: mobileImage.dataset.mobileImage,
          alt: mobileImage.dataset.mobileImageAltText,
          height: mobileImage.dataset.mobileImageHeight,
          width: mobileImage.dataset.mobileImageWidth
        };
      } else {
        return null;
      }
    }
  }, {
    key: "_getComponentVideo",
    value: function _getComponentVideo(video) {
      return {
        src: video.src,
        type: video.type
      };
    }
  }, {
    key: "_getComponentIframe",
    value: function _getComponentIframe(iframe) {
      return {
        src: iframe.src,
        width: iframe.width,
        height: iframe.height,
        frameBorder: iframe.frameborder
      };
    }
  }, {
    key: "_getComponentHtml",
    value: function _getComponentHtml(html) {
      return {
        html: html.innerHTML
      };
    }
  }, {
    key: "_getComponentLink",
    value: function _getComponentLink(link) {
      return {
        href: link.href,
        pathname: link.pathname,
        search: link.search,
        content: link.innerHTML,
        class: link.className,
        target: link.target,
        title: link.title,
        hash: link.hash
      };
    }
  }, {
    key: "_getComponentNewsNavigation",
    value: function _getComponentNewsNavigation(linkList) {
      var listElements = linkList.querySelectorAll('li');
      var elements = [];
      listElements.forEach(function (li) {
        var link = li.querySelector('a');
        elements.push({
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "_getComponentText",
    value: function _getComponentText(element) {
      return {
        text: element.innerText
      };
    }
  }, {
    key: "_getComponentNewsListSpot",
    value: function _getComponentNewsListSpot(newsListSpot) {
      var listElements = newsListSpot.querySelectorAll('li');
      var elements = [];
      listElements.forEach(function (li) {
        var image = li.querySelector('.news-image img');
        var header = li.querySelector('.news-header').innerHTML;
        var location = li.querySelector('.news-location').innerHTML;
        var date = li.querySelector('.news-date h4').innerHTML;
        var text = li.querySelector('.news-text').innerHTML;
        var link = li.querySelector('.news-link a');
        elements.push({
          image: image,
          header: header,
          location: location,
          date: date,
          text: text,
          link: link
        });
      });
      return elements;
    }
  }, {
    key: "_getComponentImageSpotList",
    value: function _getComponentImageSpotList(list) {
      var listElements = list.querySelectorAll('.image-spot-element');
      var imageSpots = [];
      listElements.forEach(function (el) {
        var image = el.querySelector('.image-spot-element-image img');
        var imageDescription = el.querySelector('.image-spot-element-image-description');
        var header = el.querySelector('.image-spot-element-header');
        var text = el.querySelector('.image-spot-element-text');
        var contextContent = el.querySelector('.image-spot-element-context-content');
        var link = el.querySelector('.image-spot-element-link a');
        var sitecoreItem = el.querySelector('div[sc_item]');
        var sitecoreChromeData = el.querySelector('.scChromeData');
        var spot = {
          image: image === null ? null : image,
          imageDescription: imageDescription === null ? null : imageDescription.innerText,
          header: header === null ? null : header.innerHTML,
          text: text === null ? null : text.innerHTML,
          contextContent: contextContent === null ? null : contextContent.innerHTML,
          link: link === null ? null : ComponentDataReceiver._getComponentLink(link),
          sitecoreItem: sitecoreItem === null ? null : sitecoreItem.getAttribute('sc_item'),
          sitecoreChromeData: sitecoreChromeData === null ? null : sitecoreChromeData.textContent
        };
        imageSpots.push(spot);
      });
      return imageSpots;
    }
  }, {
    key: "_getComponentColorSpot",
    value: function _getComponentColorSpot(content) {
      var images = content.querySelectorAll('.images li');
      var colors = content.querySelector('.color-picker');
      var names = content.querySelector('.color-picker-name');
      var list = [];
      images.forEach(function (el) {
        var image = el.querySelector('img');
        var className = el.classList[0];
        var color = colors.getElementsByClassName(className)[0].querySelector('a');
        var name = names.getElementsByClassName(className)[0].querySelector('a');
        var item = {
          name: name === null ? null : name.getAttribute('title'),
          image: image === null ? null : ComponentDataReceiver._getComponentImage(image),
          colors: color === null ? null : color.getAttribute('style').replace('background-color: ', '').split(' ')
        };
        list.push(item);
      });
      return list;
    }
  }, {
    key: "_getComponentImageComponent",
    value: function _getComponentImageComponent(component) {
      var link = component.querySelector('a');
      var image = component.querySelector('img');
      return {
        link: link === null ? null : ComponentDataReceiver._getComponentLink(link),
        image: image === null ? null : ComponentDataReceiver._getComponentImage(image)
      };
    }
  }, {
    key: "_getComponentNavigation",
    value: function _getComponentNavigation(navigation) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var hookClass = ".level".concat(i);
      var currentNode = navigation.querySelectorAll("li".concat(hookClass));
      var globalNav = [];
      i += 1;
      var groupLinks = function groupLinks(array, key) {
        var map = new Map();
        array.forEach(function (item) {
          var k = key(item);
          var collection = map.get(k);
          !collection ? map.set(k, [item]) : collection.push(item);
        });
        var sortedMap = new Map(_toConsumableArray(map.entries()).sort());
        return _toConsumableArray(sortedMap.values());
      };
      currentNode.forEach(function (node) {
        var nav = {
          link: null,
          nestedLinks: null,
          groupedNestedLinks: null
        };
        var link = node.querySelector("li".concat(hookClass, " > a"));
        var nestedLinks = node.querySelector("li".concat(hookClass, " > ul"));
        nav.link = ComponentDataReceiver._getComponentLink(link);
        if (nestedLinks !== null) {
          nav.nestedLinks = ComponentDataReceiver._getComponentNavigation(nestedLinks, i);
          var groupedLinks = nestedLinks.querySelectorAll(":scope > li[class^=\"group-\"]");
          if (groupedLinks.length > 0) {
            nav.groupedNestedLinks = groupLinks(nav.nestedLinks, function (el) {
              return el.link.class;
            });
          }
        }
        globalNav.push(nav);
      });
      return globalNav;
    }
  }, {
    key: "_getComponentLinkList",
    value: function _getComponentLinkList(list) {
      var listElements = list.querySelectorAll('li');
      var linkList = [];
      listElements.forEach(function (el) {
        var linkElement = el.querySelector('a');
        var link = ComponentDataReceiver._getComponentLink(linkElement);
        linkList.push(link);
      });
      return linkList;
    }
  }, {
    key: "_getComponentSearch",
    value: function _getComponentSearch(element) {
      return {
        searchUrl: element.dataset.resultPage
      };
    }
  }, {
    key: "_getComponentBreadcrumb",
    value: function _getComponentBreadcrumb(element) {
      var list = element.querySelector('ol');
      var linkList = ComponentDataReceiver._getComponentLinkList(list);
      var blueText = element.classList.contains('text-blue-85');
      return {
        linkList: linkList,
        blueText: blueText
      };
    }
  }, {
    key: "_getComponentBlogCategories",
    value: function _getComponentBlogCategories(element) {
      var links = element.querySelectorAll('a');
      var categories = [];
      links.forEach(function (link) {
        categories.push(ComponentDataReceiver._getComponentLink(link));
      });
      return categories;
    }
  }, {
    key: "_getComponentJson",
    value: function _getComponentJson(jsonScript) {
      return JSON.parse(jsonScript.textContent);
    }
  }]);
}();